import { baseRoute } from '../../../constants/routes';

export const EXITS_ROUTE = baseRoute + '/statistics/questions';
export const EXITS_HATCH_ROUTE = baseRoute + '/statistics/hatch';

export const GET_EXITS = 'GET_EXITS';
export const GET_EXITS_SUCCESS = 'GET_EXITS_SUCCESS';
export const GET_HATCH_EXITS = 'GET_HATCH_EXITS';
export const GET_HATCH_EXITS_PARAM = 'GET_HATCH_EXITS_PARAM';

export const GET_HATCH_EXITS_SUCCESS = 'GET_HATCH_EXITS_SUCCESS';